export const timeFromIsoDate = (isoDate: string) => {
  const formated = isoDate.match(/\d\d:\d\d/);
  return formated ? formated[0] : '';
};
